import { Col, Row, Space } from "antd";
import { toNumber } from "helper/common";
import React, { useState } from "react";
const VitalSigns = (props) => {
  const [decimalValue, setDecimalValue] = useState(null);
  const nurseInfo1 = (data) => {
    return [
      //  {label: "Nhiệt độ", value: data?.Temperature},
      //  {label: "Mạch", value: data?.Pulse},
      //  {label: "Nhịp thở", value: data?.RR},
      //  {label: "Huyết áp", value: data?.BloodPressure},
      //  {label: "SPO2", value: data?.Sp02},
      { label: "Chiều cao", value: data?.Height },
      { label: "Cân nặng", value: data?.Weight },
      { label: "BMI", value: data?.BMI },
    ];
  };
  const nurseInfo2 = (data) => {
    return [
      { label: "Huyết áp", value: data?.BloodPressure },
      { label: "Mạch", value: data?.Pulse },
      { label: "Nhịp thở", value: data?.RR },
      { label: "SPO2", value: data?.Sp02 },
      { label: "Nhiệt độ", value: data?.Temperature },
    ];
  };
  const suffix = (label) => {
    switch (label) {
      case "Nhiệt độ":
        return "°C";
      case "Mạch":
        return "lần/phút";
      case "Nhịp thở":
        return "lần/phút";
      case "Huyết áp":
        return "mmHg";
      case "SPO2":
        return "%";
      case "Chiều cao":
        return "cm";
      case "Cân nặng":
        return "kg";
      case "BMI":
        return "kg/m2";
      default:
        return "";
        break;
    }
  };
  const { data } = props;

  const isNumberInRange = (number) => {
    const isSplit = number.split("/").map(Number);

    const numeratorMin = 90;
    const numeratorMax = 140;
    const denominatorMin = 60;
    const denominatorMax = 90;

    const isNumeratorInRange =
      isSplit[0] > numeratorMin && isSplit[0] < numeratorMax;

    const isDenominatorInRange =
      isSplit[1] > denominatorMin && isSplit[1] < denominatorMax;

    if (isNumeratorInRange && isDenominatorInRange) {
      return true;
    } else return false;
  };
  const checkInRange = (label, value) => {
    if (label == "Huyết áp") {
      return isNumberInRange(value);
    }
    if (label == "Mạch") {
      return toNumber(value) < 90;
    }
    if (label == "Nhịp thở") {
      return toNumber(value) <= 80 && toNumber(value) >= 60;
    }
    if (label == "SPO2") {
      return toNumber(value) <= 100 && toNumber(value) >= 80;
    }
    if (label == "Nhiệt độ") {
      return toNumber(value) <= 37.5 && toNumber(value) >= 36.5;
    } else return true;
  };
  return (
    <div className="vital-signs">
      <Row gutter={[4, 4]}>
        {nurseInfo2(data).map((item) => {
          return (
            <>
              {item?.value &&
                item?.value?.Result?.length > 0 &&
                item?.value?.Result.findIndex((result) => result?.value) !=
                  -1 && (
                  <Col span={8}>
                    <div
                      style={{
                        fontWeight: "600",
                        marginRight: 4,
                        marginTop: 8,
                      }}
                    >
                      {item.label}:
                    </div>
                    <Space
                      direction="vertical"
                      size={"middle"}
                      // style={{ paddingLeft: 20 }}
                    >
                      {item?.value?.Result?.map((result) => {
                        return (
                          <>
                            {result?.value && (
                              <Row className="content-chirld">
                                <div style={{ width: 250 }}>
                                  <span>• Kết quả: </span>
                                  <span
                                    style={{
                                      color: checkInRange(
                                        item.label,
                                        result?.value
                                      )
                                        ? "black"
                                        : "red",
                                    }}
                                  >
                                    {result?.value} {suffix(item.label)}
                                  </span>
                                </div>
                                {/* <div>
                                  <span>Thời gian:</span> {result?.min}
                                </div> */}
                              </Row>
                            )}
                          </>
                        );
                      })}
                    </Space>
                  </Col>
                )}{" "}
            </>
          );
        })}
      </Row>
      <Row gutter={[4, 4]}>
        {nurseInfo1(data).map((item) => {
          return (
            <>
              {item?.value && item?.value != "--" && (
                <Col span={8}>
                  <Row>
                    <span style={{ fontWeight: "600", marginRight: 4 }}>
                      {`${item.label}:`}{" "}
                    </span>{" "}
                    <span className="" style={{ paddingRight: "5px" }}>
                      {item.value ?? "--"}
                    </span>{" "}
                    {suffix(item.label)}
                  </Row>
                </Col>
              )}{" "}
            </>
          );
        })}
      </Row>
    </div>
  );
};
export default VitalSigns;
